import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import MenuEntrenador from '../components/MenuEntrenador';
import EjercicioModal from '../components/EjercicioModal';
import { supabase } from '../lib/supabase';

const diasSemana = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

export default function EntrenadorDashboard() {
  const { user } = useAuth();
  const [rutina, setRutina] = useState<{ [dia: string]: any[] }>({});
  const [modalDia, setModalDia] = useState<string | null>(null);
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    async function insertarRutinaBase() {
      if (!user?.id) return;

      const { error } = await supabase.from('rutinas').insert([
        {
          nombre: 'Rutina Base',
          nivel: 'Intermedio',
          ejercicios: [],
          entrenador_id: user.id,
        },
      ]);

      if (error) {
        console.error('❌ Error al insertar rutina base:', error.message);
        setMensaje('❌ No se pudo crear la rutina base');
      } else {
        setMensaje('✅ Rutina creada correctamente');
      }
    }

    insertarRutinaBase();
  }, []); // ✅ COMA + ARRAY que cierra perfectamente
  

  return (
    <>
      <MenuEntrenador />
      <div className="p-6">
        <h2 className="text-2xl font-bold mb-4">📋 Panel del Entrenador</h2>
        <p className="mb-4 text-green-600">{mensaje}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {diasSemana.map((dia) => (
            <div key={dia} className="border rounded-lg p-4 shadow-md bg-white">
              <h3 className="text-lg font-semibold mb-2">{dia}</h3>
              <button
                onClick={() => setModalDia(dia)}
                className="text-sm bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded"
              >
                + Agregar ejercicio
              </button>
              <ul className="mt-2 text-sm">
                {(rutina[dia] || []).map((ejercicio, idx) => (
                  <li key={idx}>
                    {ejercicio.nombre} — {ejercicio.series}×{ejercicio.repeticiones}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {modalDia && (
          <EjercicioModal
            dia={modalDia}
            onClose={() => setModalDia(null)}
            onGuardar={(ejercicio) => {
              const dia = ejercicio.dia;
              setRutina((prev) => ({
                ...prev,
                [dia]: [...(prev[dia] || []), ejercicio],
              }));
            }}
          />
        )}
      </div>
    </>
  );
}
